import { useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import { EventRegister } from "react-native-event-listeners";

export const useHidingTabBar = (keepHidden: boolean = false) => {
  useIonViewWillEnter(() => {
    EventRegister.emit("tab-bar/visibility-changed", false);
  });

  useIonViewWillLeave(() => {
    !keepHidden && EventRegister.emit("tab-bar/visibility-changed", true);
  });
};
